import {
  DefaultFetchError,
  FetchCreate,
  useFetchCreate,
  FetchGetId,
  useFetchGetId,
} from "./fetch";
import { RecordingType } from "../hooks/api/recordings";

interface UploadFileSuccess {
  id: string;
  originalName: string;
  url?: string;
}

// export const useUploadFile = (
//   uploadUrl = "files/upload",
//   authorization = true,
// ): FetchCreate<UploadFileSuccess, DefaultFetchError, FormData> =>
//   useFetchCreate(uploadUrl, {
//     config: {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     },
//     authorization,
//   });
export const useUploadFile = (
  uploadUrl = "files/upload",
  authorization = true,
  keepOriginalName = true,
): FetchCreate<UploadFileSuccess, DefaultFetchError, FormData> =>
  useFetchCreate(uploadUrl + (keepOriginalName ? "?keepName=yes" : ""), {
    config: {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
    authorization,
  });

export const useDownloadFile = (
  abortController: AbortController,
): FetchGetId<ArrayBuffer> =>
  useFetchGetId(
    "files",
    "",
    {
      autoStart: false,
      startStateLoading: false,
      config: {
        headers: { "content-type": "multipart/form-data" },
        signal: abortController.signal,
      },
    },
    "arraybuffer",
  );

export default {
  useUploadFile,
};

export const downloadFile = async (
  url: string,
  filename: string,
): Promise<void> => {
  try {
    const response = await fetch(url, {
      method: "GET",
    });

    if (!response.ok)
      throw new Error(`Network response was not ok: ${response.status}`);

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Download failed:", error);
    throw error;
  }
};
